import React from 'react';
import Styles from './index.module.scss'
import {copyAllText, copyText} from "@/utils/publicFun";

const CodeModal = ({ onClose, codeList }) => {

  const copyAll = () => {
    if(codeList) {
      copyAllText(codeList.join('\n'), document.getElementById("list"))
    }
  }
  const handleClick = () => {
    onClose && onClose();
  }

  return <div className={Styles.codeModal}>
    <div className={Styles.codeOuter}>
      <div className={Styles.codeTitle}>兑换码</div>
      <div id="list" className={Styles.codeContent}>
        {codeList.map((item, index) => <p id={item} key={index} className={Styles.rowBox}>
          {item}
          <img
            className={Styles.copyIcon}
            src={require("@/assets/img/order-detail/copy.png")}
            onClick={() => copyText(item, document.getElementById(item))}
            alt=""
          />
        </p>)}
      </div>
      <div className={Styles.btnBox}>
        <div className={Styles.btn1} onClick={copyAll}>一键复制</div>
        <div className={Styles.btn2} onClick={handleClick}>关闭</div>
      </div>
    </div>
  </div>
}

export default CodeModal